import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import PrimaryOutLineButton from "../component/PrimaryOutLineButton";
import DefaultImage from "../assets/images/productDefault.png";
const SingleProduct = ({
  cuponeCode,
  onClickWishList,
  productName,
  shortDesc,
  price,
  tdsTxt,
  getTxt,
  productImage,
  heart,
  onClick,
  hartpicenable,
  passedObject,
  onClickCart,
  oneButtom,
  unblockBtnvisiblity
}) => {
  return (
    <>
      <div className="itemProductWrap">
        <div className="itemWrapImage">
          {hartpicenable !== false ? (
            <div className="wishListIcon" onClick={onClickWishList}>
              <img src={heart} alt="wishList" className="wishListIconImg" />
            </div>
          ) : (
            ""
          )}

          {productImage.endsWith("null") ? (
            <img src={DefaultImage} alt={DefaultImage} />
          ) : (
            <img src={productImage} alt={productName} />
          )}
        </div>
        <div className="itemWrapImageTxt">
          <p className="titleTxt">{productName}</p>
          <p className="descTxt">{cuponeCode}</p>
          <p className="pointsTxt">
            {price} <span>Points *</span>
          </p>
          <p className="tdsApplyTxt">{tdsTxt}</p>
          <p className="getItTxt">{getTxt}</p>
          <p className="additionalInfoTxt">{passedObject}</p>
          <Row className="btnWrap align-items-center">
            {oneButtom == true ? (
              <Col xs={12} xxl={12}>
                <div className="col-12 d-flex justify-content-right">
                  <div className="d-flex  ">
                    {unblockBtnvisiblity?

                    
                    <PrimaryGradientButton
                      className="primaryBtn undefined btn btn-primary "
                      buttonText="Unlock Now"
                      onClick={onClickCart}
                    />
                  :
                  
                  <PrimaryGradientButton
                    className="primaryBtn undefined btn btn-primary "
                    buttonText="Unlock Now"
                    onClick={onClickCart}
                    disabled={true}
                  />}
                  </div>
                </div>
              </Col>
            ) : (
              <Col xs={12} xxl={12}>
                <div className="d-flex ad-btn-2 ad-gap-10">
                  <PrimaryOutLineButton
                    className="outlineBtn  undefined btn btn-primary"
                    outlinebuttonText="View More"
                    onClick={onClick}
                  />
                  <PrimaryGradientButton
                    className="primaryBtn undefined btn btn-primary"
                    buttonText="Add To Cart"
                    onClick={onClickCart}
                  />
                </div>
              </Col>
            )}
          </Row>
        </div>
      </div>
    </>
  );
};

export default SingleProduct;
